module.exports = __webpack_public_path__ + "img/bootstraplogo.346548a9.png";